var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPencilFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 16h1.261L13.498 5.764l-1.261-1.262L2 14.738V16Zm-.596 1.5a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644v-1.732a1.8 1.8 0 0 1 .527-1.275L13.691.93c.15-.138.318-.244.5-.319A1.5 1.5 0 0 1 14.766.5c.2 0 .395.036.583.107.188.07.354.184.499.34l1.221 1.236c.155.145.266.311.332.5.066.188.099.377.099.565 0 .201-.034.393-.103.576-.069.183-.178.35-.328.501L4.412 16.973a1.8 1.8 0 0 1-1.276.527H1.404ZM12.856 5.144l-.62-.642 1.262 1.261-.642-.62Z",
  fill: "currentColor"
})));

export default SvgPencilFilled;